import { createAction } from 'redux-actions';

export const GET_OFFERS_REQUEST = createAction('GET_OFFERS_REQUEST');
export const GET_OFFERS_FAILURE = createAction('GET_OFFERS_FAILURE');
export const GET_OFFERS_SUCCESS = createAction('GET_OFFERS_SUCCESS');
